import React, { FC } from "react";
import ReactDOM from "react-dom";
import ClickOffComponentWrapper from "layout/ClickOffComponentWrapper/ClickOffComponentWrapper";

interface IProps {
  children: React.ReactNode;
  id: string;
  onClose: (id: string) => void;
  // classname for portal content element
  className?: string;
  // style for portal content element
  style?: React.CSSProperties;
  // Use if you want to block auto close modal on outer click. Example is clicking on Toast that will close modal
  noOuterClose?: boolean;
  isReport?: boolean;
}

const Portal: FC<IProps> = ({ children, id, onClose, className, style, noOuterClose, isReport }) => {
  const handleClose = () => {
    if (!noOuterClose && onClose) {
      const portals = document?.getElementsByClassName("portal-container");
      if (id === portals[portals.length - 1]?.id) {
        onClose(id);
      }
    }
  };

  return ReactDOM.createPortal(
    <div className={`portal-container ${isReport ? 'is-report' : ''}`} id={id} data-tid={id}>
      <ClickOffComponentWrapper onOuterClick={handleClose}>
        <div
          className={`
        portal-content ${className || ""}`}
          style={style}
        >
          {children}
        </div>
      </ClickOffComponentWrapper>
    </div>,
    document.body
  );
};

export default Portal;
